import angular from 'angular';

const loginControllers = angular.module('loginModule.loginControllers', []);

class LoginController {
    constructor($scope, $rootScope, $state, $http, $stateParams, $modal, growl, AppsoupAPI, loginService) {
        const token = $stateParams.token;

        if (angular.isDefined(loginService.isLogged) && loginService.isLogged && angular.isDefined(loginService.defaultState)) {
            $state.go(loginService.defaultState);
            $rootScope.$broadcast('newApp');
        }

        $scope.passForgot = () => {
            $modal.open({
                templateUrl: 'views/login/components/modal/remindPassword.tpl.html',
                controller: 'PasswordRemindModalController',
                size: 'md'
            });
        };

        if (angular.isDefinedNotEmpty(token)) {
            $http.get(`${AppsoupAPI.API_URL}/password/check/${token}`)
                .then(({data}) => {
                    if (!data.success) {
                        growl.error('ERROR.EXPIRED_TOKEN');
                    } else {
                        $modal.open({
                            templateUrl: 'views/login/components/modal/resetPassword.tpl.html',
                            controller: 'PasswordResetModalController',
                            size: 'md',
                            resolve: {
                                token: () => token
                            }
                        });
                    }
                });
        }
    }
}

class PasswordRemindModalController {
    constructor($scope, $http, $modalInstance, growl, AppsoupAPI) {
        $scope.ok = () => {
            $scope.$broadcast('show-errors-check-validity');

            if ($scope.forgotForm.$valid) {
                $scope.isLoading = true;
                $http.post(`${AppsoupAPI.API_URL}/password/remind`, {email: $scope.email})
                    .then(({data}) => {
                        if (data.success) {
                            $modalInstance.close();
                            growl.success('USER.RESET_EMAIL_SUCCESS');
                        } else {
                            growl.error(data.error);
                        }
                    })
                    .finally(() => {
                        $scope.isLoading = false;
                    });
            }
        };

        $scope.cancel = () => {
            $modalInstance.dismiss('cancel');
        };
    }
}

class PasswordResetModalController {
    constructor($scope, $http, $modalInstance, growl, token, AppsoupAPI) {
        $scope.user = {token};

        $scope.passMismatched = () => {
            return $scope.resetForm.repeatPass.$error.match;
        };

        $scope.$watchGroup(['user.password_confirmation', 'user.password'], () => {
            if (angular.isDefined($scope.user.password) && angular.isDefined($scope.user.password_confirmation)) {
                const isValid = !($scope.user.password !== $scope.user.password_confirmation && !$scope.resetForm.repeatPass.$pristine);
                $scope.resetForm.repeatPass.$setValidity('match', isValid);
            }
        });

        $scope.ok = () => {
            $scope.$broadcast('show-errors-check-validity');

            if ($scope.resetForm.$valid) {
                $scope.isLoading = true;
                $http.post(`${AppsoupAPI.API_URL}/password/reset`, $scope.user)
                    .then(({data}) => {
                        if (data.success) {
                            $modalInstance.close();
                            growl.success('USER.PASS_RESET_SUCCESS');
                        } else {
                            growl.error(data.error);
                        }
                    })
                    .finally(() => {
                        $scope.isLoading = false;
                    });
            }
        };

        $scope.cancel = () => {
            $modalInstance.dismiss('cancel');
        };

        $scope.inputErrors = {
            'email': [{type: '$invalid', msg: 'ERROR.REQUIRE.EMAIL'}],
            'password': [
                {error: 'required', msg: 'ERROR.REQUIRE.PASS'},
                {error: 'minlength', msg: 'ERROR.MIN_LENGTH.PASS', vars: '{ charsQty: 6 }'}
            ],
            'repeatPass': [
                {error: 'required', msg: 'ERROR.REQUIRE.PASS'},
                {error: 'minlength', msg: 'ERROR.MIN_LENGTH.PASS', vars: '{ charsQty: 6 }'}
            ]
        };
    }
}

class BodyController {
    constructor($scope, $state, $stateParams, $filter, loginService, accessService, $http, $timeout, AppsoupAPI) {
        $scope.$state = $state;
        $scope.$stateParams = $stateParams;

        $scope.applicationsStates = [
            'news', 'dishes', 'games', 'notes', 'ads', 'levels', 'products', 'reviews',
            'shops', 'users', 'messages', 'exhibitors', 'order', 'meetings', 'gamifications',
            'chats', 'maps', 'posts', 'competitions', 'groups', 'files', 'sso', 'libraries',
            'galleries', 'forms', 'polls', 'recipes', 'promotions', 'newspapers', 'evaluations',
            'banners', 'level_rebuses', 'rebuses', 'logs', 'price_lists', 'coupons',
            'integrations', 'users_www', 'categories', 'shopping_lists', 'facets',
            'short_codes', 'themes'
        ];

        $scope.getStateIconClass = function (state) {
            let iconClass = '';
            switch (state) {
                case 'news':
                    iconClass = 'fa fa-newspaper-o';
                    break;
                case 'dishes':
                    iconClass = 'fa fa-spoon';
                    break;
                case 'games':
                    iconClass = 'fa fa-gamepad';
                    break;
                case 'notes':
                    iconClass = 'glyphicon glyphicon-list-alt';
                    break;
                case 'ads':
                    iconClass = 'glyphicon glyphicon-volume-up';
                    break;
                case 'levels':
                    iconClass = 'fa fa-map-marker';
                    break;
                case 'products':
                    iconClass = 'glyphicon glyphicon-picture';
                    break;
                case 'reviews':
                    iconClass = 'fa fa-comments-o';
                    break;
                case 'sections':
                    iconClass = 'glyphicon glyphicon-th-large';
                    break;
                case 'shops':
                    iconClass = 'glyphicon glyphicon-shopping-cart';
                    break;
                case 'users':
                    iconClass = 'glyphicon glyphicon-user';
                    break;
                case 'messages':
                    iconClass = 'glyphicon glyphicon-envelope';
                    break;
                case 'exhibitors':
                    iconClass = 'glyphicon glyphicon-credit-card';
                    break;
                case 'order':
                    iconClass = 'glyphicon glyphicon-gift';
                    break;
                case 'meetings':
                    iconClass = 'fa fa-users';
                    break;
                case 'gamifications':
                    iconClass = 'fa fa-futbol-o';
                    break;
                case 'chats':
                    iconClass = 'fa fa-weixin';
                    break;
                case 'maps':
                    iconClass = 'fa fa-map';
                    break;
                case 'posts':
                    iconClass = 'fa fa-map';
                    break;
                case 'groups':
                    iconClass = 'fa fa-users';
                    break;
                case 'competitions':
                    iconClass = 'fa fa-bullseye';
                    break;
                case 'files':
                    iconClass = 'glyphicon glyphicon-picture';
                    break;
                case 'sso':
                    iconClass = 'fa fa-plug';
                    break;
                case 'libraries':
                    iconClass = 'fa fa-file-text';
                    break;
                case 'galleries':
                    iconClass = 'fa fa-file-image-o';
                    break;
                case 'forms':
                    iconClass = 'fa fa-tasks';
                    break;
                case 'polls':
                    iconClass = 'fa fa-check-square-o';
                    break;
                case 'recipes':
                    iconClass = 'fa fa-spoon';
                    break;
                case 'promotions':
                    iconClass = 'fa fa-percent';
                    break;
                case 'newspapers':
                    iconClass = 'fa fa-newspaper-o';
                    break;
                case 'evaluations':
                    iconClass = 'fa fa-newspaper-o';
                    break;
                case 'banners':
                    iconClass = 'fa fa-file-image-o';
                    break;
                case 'level_rebuses':
                    iconClass = 'fa fa-gamepad';
                    break;
                case 'rebuses':
                    iconClass = 'fa fa-gamepad';
                    break;
                case 'logs':
                    iconClass = 'fa fa-database';
                    break;
                case 'price_lists':
                    iconClass = 'fa fa-calculator';
                    break;
                case 'coupons':
                    iconClass = 'fa fa-credit-card';
                    break;
                case 'integrations':
                    iconClass = 'fa fa-codepen';
                    break;
                case 'users_www':
                    iconClass = 'fa fa-user';
                    break;
                case 'categories':
                    iconClass = 'fa fa-book';
                    break;
                case 'shopping_lists':
                    iconClass = 'glyphicon glyphicon-shopping-cart';
                    break;
                case 'facets':
                    iconClass = 'fa fa-tags';
                    break;
                case 'short_codes':
                    iconClass = 'fa fa-code';
                    break;
                case 'themes':
                    iconClass = 'glyphicon glyphicon-bookmark';
                    break;
            }

            return iconClass;
        };

        $scope.translated = function (state) {
            state = $filter('uppercase')(state);

            return $filter('translate')('MENU.' + state);
        };

        $scope.ls = loginService;
        $scope.login = {
            working: false,
            wrong: false
        };

        $scope.loginMe = () => {
            const loginData = {
                email: $scope.login.username,
                password: $scope.login.password
            };

            const loginPromise = $http.post(`${AppsoupAPI.API_URL}/login`, loginData);
            $scope.login.working = true;
            $scope.login.wrong = false;

            loginService.loginUser(loginPromise);
            loginPromise.catch(() => {
                $scope.login.wrong = true;
                $timeout(() => {
                    $scope.login.wrong = false;
                }, 8000);
            });
            loginPromise.finally(() => {
                $scope.login.working = false;
            });
        };

        $scope.logoutMe = () => {
            loginService.logoutUser($http.get(`${AppsoupAPI.API_URL}/logout`));
        };

        $scope.userHasPermission = (stateName) => {
            return accessService.userHasPermission($state.get(stateName), $scope.ls.userRole);
        };

        $scope.isActive = (state, menuState) => {
            const menuActive = state.current.menuActive;
            return state.current.name === menuState ||
                (angular.isDefined(menuActive) && menuActive === menuState);
        };
    }
}

// Add explicit annotation for dependency injection
LoginController.$inject = ['$scope', '$rootScope', '$state', '$http', '$stateParams', '$modal', 'growl', 'AppsoupAPI', 'loginService'];
PasswordRemindModalController.$inject = ['$scope', '$http', '$modalInstance', 'growl', 'AppsoupAPI'];
PasswordResetModalController.$inject = ['$scope', '$http', '$modalInstance', 'growl', 'token', 'AppsoupAPI'];
BodyController.$inject = ['$scope', '$state', '$stateParams', '$filter', 'loginService', 'accessService', '$http', '$timeout', 'AppsoupAPI'];

loginControllers
    .controller('LoginController', LoginController)
    .controller('PasswordRemindModalController', PasswordRemindModalController)
    .controller('PasswordResetModalController', PasswordResetModalController)
    .controller('BodyController', BodyController);

export default loginControllers;
